<template>
  <div v-if="showAnnouncementBanner()">
    <v-container class="text-caption font-weight-bold py-2 text-center">
      <div class="d-flex justify-center align-center" style="gap: 12px; flex-wrap: wrap">
        <span>
          Your learner portal has a
          <button style="color: #8c1d40; text-decoration: underline" @click="openHyperlinkPage()">new look</button>!
        </span>
      </div>
    </v-container>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { useUserStore } from '../../stores';

import { DataLayerMixin } from '../../mixins/dataLayerMixin';
export default defineComponent({
  mixins: [DataLayerMixin],
  name: 'AnnouncementBanner',

  setup() {
    const userStore = useUserStore();
    return { userStore };
  },

  methods: {
    openHyperlinkPage() {
      const linkURL =
        'https://docs.google.com/presentation/d/1QRjA-UDFUodMwRGxfSP6gnjlMUF1fDEqzT5Q69SDRCw/edit?slide=id.g34b98642329_0_10183#slide=id.g34b98642329_0_10183';
      this.asuoDataLayerClick('accelerateDashboard', '24', { section: 'announcement banner', text: 'new look' });
      window.open(linkURL, '_blank');
    },
    showAnnouncementBanner() {
      // Temp: Set banner flag to false
      return false;
      // Do not show the new update banner for yakima
      return (
        this.userStore.apis?.learnerData?._partnerURLSubDomain === 'accelerate' &&
        !this.userStore.apis?.learnerData?._partnerName?.includes('Yakima')
      );
    }
  }
});
</script>
